import { supabaseClient } from "../config/supabase-clients";

export const GetMaintenance = async (page) => {
    const { data: data, error } = await supabaseClient.from('maintenance_pages').select('*').eq('page', page).single();
    if (error) {
        return error;
    }
    return data;
}